const apiError = 'api_error';
const domError = 'dom_error';
const inputValidationError = 'input_validation_error';
const redundantMethodCallError = 'redundant_method_call_error';
const generalError = 'general_error';

export { apiError, domError, generalError, inputValidationError, redundantMethodCallError };
